// extracted by mini-css-extract-plugin
export var experience = "Experience-module--experience--FsPjj";
export var experience__tabs = "Experience-module--experience__tabs--kiWTT";
export var experience__tabs__button = "Experience-module--experience__tabs__button--9v7Lq";
export var not_active_button = "Experience-module--not_active_button--HzBVB";
export var experience__content = "Experience-module--experience__content--Up2Vf";
export var card = "Experience-module--card--kH2Kx";